// extracted by mini-css-extract-plugin
module.exports = {"discounts__list":"da51a739f7--discounts__list--N9zzV","discounts__list-item":"da51a739f7--discounts__list-item--oXwCd","show":"da51a739f7--show--mjWul"};